var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('el-button',{staticClass:"bacToIndex",attrs:{"type":"button","size":"mini"},on:{"click":_vm.backtoIndex}},[_vm._v("返回")]),_c('div',{staticClass:"iframContent"},[_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.url,"frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }